import { Card, CardContent } from "./ui/card";

export function KpiCard({ title, value, sub, color = "emerald", testId }) {
  const colors = {
    emerald: "text-emerald-600 border-emerald-200 bg-emerald-50 dark:bg-emerald-950/30 dark:border-emerald-900",
    amber: "text-amber-600 border-amber-200 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-900",
    rose: "text-rose-600 border-rose-200 bg-rose-50 dark:bg-rose-950/30 dark:border-rose-900",
    sky: "text-sky-600 border-sky-200 bg-sky-50 dark:bg-sky-950/30 dark:border-sky-900",
    slate: "text-slate-700 border-slate-200 bg-slate-50 dark:bg-slate-900 dark:border-slate-800",
  };
  return (
    <Card className={`border-2 ${colors[color] || colors.slate}`} data-testid={testId}>
      <CardContent className="p-4">
        <div className="text-xs font-mono uppercase tracking-wider text-muted-foreground">{title}</div>
        <div className="text-3xl font-heading font-extrabold mt-1">{value}</div>
        {sub && <div className="text-xs mt-1 opacity-80">{sub}</div>}
      </CardContent>
    </Card>
  );
}
